<template>
  <div class="l_invitation_faq">
    <div class="container-col-0">
      <div class="container-col-0-content">
        <button class="button" v-on:click="tapInvitation">
          <span class="c_dl">紹介リンクを送る</span>
        </button>
        <p class="text-annotation invitation-annotation">
          ※紹介リンクの有効期限は7日間です。<br />
          ※1日に紹介できるのは1名までです。<br />
          （24:00にリセットされます。）<br />
        </p>
        <p class="text-annotation-add">
          *「紹介リンクを送る」ボタン押下後のポップアップ内の「送信する」ボタンを押すと送信したものとしてカウントされます。
        </p>
      </div>
    </div>
    <p class="headline">
      <span class="headline-in"
        >アプリをお友だちに紹介すると<br />二人ともHappy♪</span
      >
    </p>
    <div class="invitation-a-b">
      <div class="you you-a">
        <p class="you-title">あなた</p>
        <img class="you-icon" :src="require('@/assets/img/faq/you@2x.png')" />
        <p class="text-annotation invitation-annotation">
          お友だちが来店*し<br />スタンプをGETすると
        </p>
        <p class="text-large">
          紹介スタンプ{{ this.inviterPoint }}個<br />GET!
        </p>
        <img
          v-for="n of this.inviterPoint"
          :key="n"
          class="you-get-stamp"
          :src="require('@/assets/img/faq/invitation-get-stamp@3x.png')"
        />
      </div>
      <div class="you you-b">
        <p class="you-title">お友だち</p>
        <img
          class="friend-icon"
          :src="require('@/assets/img/faq/friend@2x.png')"
        />
        <p class="text-annotation invitation-annotation">
          新規会員登録（無料）し<br />全ミッションを達成で
        </p>
        <p class="text-large">
          スタンプ{{ this.maxInviteePoint() }}個+<br />初回クーポンGET!
        </p>
        <img
          v-for="n of this.maxInviteePoint()"
          :key="n"
          class="you-get-stamp"
          :src="require('@/assets/img/faq/invitation-get-stamp@3x.png')"
        />
      </div>
    </div>
    <p class="text-info">
      *お友だち紹介スタンプは、紹介したお友だち1人につき1度だけ獲得できます。お友達紹介スタンプ獲得の為には、あなたが紹介リンクを送ったお友だちが紹介リンク発行後7日以内にジョイフル公式アプリをインストールし、紹介リンク発行後30日以内にジョイフル店舗にご来店して初回来店スタンプを獲得する必要がございます。
    </p>
    <div class="friend-mission">
      <div class="friend-mission-bg">
        <p class="friend-mission-title">お友だちのミッションを詳しく</p>
        <div class="friend-mission-content-wrap">
          <p class="friend-mission-content">
            新規会員登録（無料）で{{ this.inviteePoint }}個GET！
          </p>
          <p class="friend-mission-content">プロフィール設定で1個GET！</p>
          <p class="friend-mission-content">アプリ設定で1個GET！</p>
          <p class="friend-mission-content">初回来店で1個GET！</p>
        </div>
        <div class="friend-mission-footer">
          <div class="friend-mission-footer-text">
            <p>全部達成で<br />初回クーポンGET!</p>
            <span
              >(ジョイカフェorポテトフライor<br />サウザンサラダor納豆無料*)</span
            >
          </div>
          <img
            class="friend-mission-footer-img"
            :src="
              require('@/assets/img/invitation-lp/you-mission-footer-img@3x.png')
            "
          />
        </div>
      </div>
    </div>
    <p class="text-info mission-text">
      *「新規会員登録」:ジョイフル公式アプリダウンロード後、「プロフィール
      設定」画面の「設定するボタン」を押した時点で「新規会員登録」となります。<br />
      *ご利用条件、プロフィール設定、アプリ設定などの詳細はアプリ内でご確認下さい。
    </p>
    <br />
    <div class="button-adjust">
      <button class="button" v-on:click="tapInvitation">
        <span class="c_dl">紹介リンクを送る</span>
      </button>
    </div>
    <p class="text-annotation invitation-annotation">
      ※紹介リンクの有効期限は7日間です。<br />
      ※1日に紹介できるのは1名までです。<br />
      （24:00にリセットされます。）
    </p>
    <p class="text-annotation-add-adjust">
      *「紹介リンクを送る」ボタン押下後のポップアップ内の「送信する」ボタンを押すと送信したものとしてカウントされます。
    </p>
    <br />
    <p class="text-annotation text-annotation-bottom">
      紹介スタンプがうまく受け取れない場合や<br />
      ボーナス条件を知りたい時はこちらをチェック！
    </p>
    <router-link to="/invitation-info" class="invitation-info-link">
      <div class="button-detail button-adjust">
        <span>お友だち紹介について詳しく</span>
      </div>
    </router-link>

    <!-- エラーパネル -->
    <template v-if="this.isError">
      <error-popup
        :title="this.errorTitle"
        :message="this.errorMessage"
        :label="'もう一度試す'"
        @submit="() => tapRetryFetch()"
        @close="() => tapErrorClose()"
      />
    </template>
    <!-- 上限超過エラーパネル -->
    <template v-if="this.isErrorUpperLimit">
      <alert-invitation-upper-limit
        :title="this.errorTitle"
        :message="this.errorMessage"
        :label="'閉じる'"
        @close="() => tapAlertInvitationUpperLimitClose()"
      />
    </template>
    <!-- アラート表示 -->
    <template v-if="this.isUseAlert">
      <alert-invitation
        @sendInvitation="tapSendInvitation"
        @close="tapAlertInvitationClose"
      />
    </template>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import DateFormatter from '../utils/DateFormatter.js'
import AlertInvitation from '../components/Modal/AlertInvitation'
import AlertInvitationUpperLimit from '../components/Modal/AlertInvitationUpperLimit'
import ErrorPopup from '../components/Modal/ErrorPopup'
import APIClient, {
  ErrorCode,
  ErrorMessage,
  isNonError
} from '../api/APIClient'
import { UPPER_LIMIT_STATUS } from '../store/invitation'
import { FactoryTrack } from '@/constant/firebase'
import '@/styles/color.css'

export default {
  name: 'FAQInvitation',
  components: {
    AlertInvitation,
    AlertInvitationUpperLimit,
    ErrorPopup
  },
  data: function() {
    return {
      isError: false,
      isErrorUpperLimit: false,
      errorMessage: '',
      errorTitle: '',
      isUseAlert: false,
      inviterPoint: 2,
      inviteePoint: 2
    }
  },
  watch: {
    sendRegisterErrorItem: function(value) {
      if (isNonError(value)) {
        this.isError = false
        return
      }
      this.errorTitle = value.title
      this.errorMessage = value.message
      this.isError = true
    },
    invitationData: function(value) {
      this.action_ToggleModal(false)
      this.actionToggleLoading(false)
      this.actionSendRegisterInvitationData({
        title: value.title,
        description: value.description,
        invitation_url: value.invitation_url,
        invitee_expire_at: value.invitee_expire_at,
        invitee_point: value.invitee_point,
        invitation_uuid: value.invitation_uuid
      })
    },
    upperLimitStatus: function(value) {
      this.isErrorUpperLimit =
        value === UPPER_LIMIT_STATUS.UPPER_LIMIT_OVER_ON_CAMPAIGN ||
        value === UPPER_LIMIT_STATUS.UPPER_LIMIT_OVER
    }
  },
  created() {
    document.title = 'アプリをお友だちに紹介'

    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.fetchInvitationMasters(
          json.app_token,
          json.acc_time,
          json.user_id,
          json.client_id
        )
        window.receivedToken = null
      }
      this.actionRequestToken({
        apiType: '9',
        acc_time: accTime
      })
    } catch (e) {
      console.log(e)
    }
  },
  computed: {
    ...mapGetters({
      invitationData: 'Invitation/invitationData',
      upperLimitStatus: 'Invitation/upperLimitStatus',
      sendRegisterErrorItem: 'Invitation/errorItem'
    })
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Native', [
      'actionRequestToken',
      'actionSendRegisterInvitationData'
    ]),
    ...mapActions('Loading', ['actionToggleLoading']),
    ...mapActions('Modal', ['action_ToggleModal']),
    ...mapActions('Invitation', [
      'actionSendRegisterInvitation',
      'actionClearUpperLimit',
      'actionClearAPIError'
    ]),
    goBack: function() {
      this.action_ToggleModal(false)
      this.$router.push({ name: 'FAQ' })
    },
    tapInvitation() {
      this.trackEvent(FactoryTrack.createInvitationAlertOpen())
      this.action_ToggleModal(true)
      this.isUseAlert = true
    },
    tapErrorClose() {
      this.trackEvent(FactoryTrack.createErrorClose())
      this.errorClose()
    },
    tapRetryFetch() {
      this.trackEvent(FactoryTrack.createErrorRetry())
      this.tapInvitation()
    },
    tapAlertInvitationUpperLimitClose() {
      this.trackEvent(FactoryTrack.createInvitationUpperLimitAlertClose())
      this.errorClose()
    },
    tapAlertInvitationClose() {
      this.trackEvent(FactoryTrack.createInvitationAlertClose())
      this.errorClose()
      this.isUseAlert = false
    },
    tapSendInvitation() {
      this.trackEvent(FactoryTrack.createSendInvitation())
      this.action_ToggleModal(true)
      this.isUseAlert = false
      this.actionToggleLoading(true)
      const accTime = new DateFormatter().format(new Date())
      try {
        window.receivedToken = payload => {
          const json = JSON.parse(payload)
          this.registerInvitation(json)
          window.receivedToken = null
        }
        this.actionRequestToken({ apiType: '9', acc_time: accTime })
      } catch (e) {
        this.actionToggleLoading(false)
        this.errorTitle = 'エラー' + ErrorCode.CODE_ERROR_TOKEN
        this.errorMessage = ErrorMessage.MSG_ERROR_TOKEN
        this.isError = true
      }
      setTimeout(() => {
        this.actionToggleLoading(false)
      }, 300)
    },
    async registerInvitation(payload) {
      await this.actionSendRegisterInvitation(payload)
    },
    async fetchInvitationMasters(token, accTime, userId, clientId) {
      this.actionToggleLoading(true)
      this.action_ToggleModal(true)
      const res = await APIClient.getInvitationMasterList(
        token,
        accTime,
        userId,
        clientId,
        ''
      )
      if (res.data.data.code === ErrorCode.CODE_SUCCESS) {
        this.inviterPoint = parseInt(
          res.data.data.invitation_master_data[0].inviter_point,
          10
        )
        this.inviteePoint = parseInt(
          res.data.data.invitation_master_data[0].invitee_point,
          10
        )
      }
      this.actionToggleLoading(false)
      this.action_ToggleModal(false)
    },
    errorClose() {
      this.action_ToggleModal(false)
      this.actionClearUpperLimit()
      this.actionClearAPIError()
    },
    maxInviteePoint() {
      return this.inviteePoint + 3
    }
  }
}
</script>

<style scoped lang="scss">
.l_invitation_faq {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;
  padding-bottom: 28px;
}
.l_invitation_faq .headline {
  padding-top: 20px;
  color: #602209;
  text-align: center;
  line-height: 1.68;
  font-size: 5.7vw;
  font-weight: 800;
  font-family: 'HiraKakuPro-W8', sans-serif;
}

.l_invitation_faq .headline-in {
  border-bottom: dotted 2.5px;
}

.l_invitation_faq .content {
  background-color: #ffffff;
  text-align: left;
}
.l_invitation_faq .content hr {
  margin-top: 10px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 1px solid #efb90f;
}
.l_invitation_faq .content img {
  padding-top: 20px;
  margin-bottom: 10px;
  max-width: 100%;
}

.l_invitation_faq img {
  width: 100%;
}

.l_invitation_faq .container-col-0 {
  background-color: #deaa07;
  border-color: #deaa07;
}

.l_invitation_faq .container-col-0 .container-col-0-content {
  padding: 33px 20px 24px;
}

.l_invitation_faq .text-annotation {
  text-align: center;
  font-size: 13px;
  line-height: 160%;
}

.l_invitation_faq .invitation-annotation {
  color: #66160E;
}

.l_invitation_faq .text-annotation-add {
  font-size: 12px;
  color: #ffffff;
  margin-top: 14px;
  text-align: left;
  line-height: 1.6;
}

.l_invitation_faq .text-annotation-add-adjust {
  font-size: 12px;
  color: #666666;
  margin-top: 12px;
  margin-left: 20px;
  margin-right: 20px;
  text-align: left;
  line-height: 1.6;
}

.l_invitation_faq .text-annotation-bottom {
  padding-bottom: 15px;
}

.l_invitation_faq .invitation-a-b {
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 25px;
  display: flex;
  justify-content: space-around;
}

.l_invitation_faq .you {
  width: 100%;
}

.l_invitation_faq .you-title {
  padding: 0.4em;
  background-color: #602209;
  border-radius: 30px;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
}

.l_invitation_faq .you-a > .you-icon {
  width: 50%;
  margin-top: 10px;
}

.l_invitation_faq .you-b > .friend-icon {
  margin-top: 10px;
  width: 36%;
}

.l_invitation_faq .you-a > p {
  margin: 0 6px 0 12px;
  font-weight: 600;
}
.l_invitation_faq .you-b > p {
  margin: 0 12px 0 6px;
  font-weight: 600;
}

.l_invitation_faq .you-get-stamp {
  padding-top: 6px !important;
  width: 20%;
}

.l_invitation_faq .friend-mission-img {
  width: 100%;
  padding-top: 8px;
  padding-left: 12px;
  padding-right: 6px;
}

.l_invitation_faq .text-info {
  font-size: 10px;
  color: #666666;
  margin: 12px 12px 0 12px;
  text-align: left;
  line-height: 1.6;
}

.l_invitation_faq .mission-text {
  padding-left: 6px;
  padding-right: 6px;
}

.l_invitation_faq .text-large {
  font-family: 'HiraKakuPro-W8', sans-serif;
  font-size: 4.5vw;
  font-weight: 800;
  color: #66160E;
}

.l_invitation_faq .button {
  display: inline-block;
  width: 100%;
  padding: 14px 0;
  margin: 0 0 14px 0;
  background-color: #602209;
  border-radius: 6px;
  color: white;
  cursor: pointer;
  border: none;
  outline: none;
  appearance: none;
}

.l_invitation_faq .button-adjust {
  margin-left: 24px;
  margin-right: 24px;
}

.l_invitation_faq .button-detail {
  padding: 14px 0;
  background-color: #ffffff;
  border-radius: 6px;
  border: 1px solid;
  color: #66160E;
}

.l_invitation_faq .button .c_dl {
  width: 100%;
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  color: #ffffff;
  padding-left: 25px;
  position: relative;
}

.l_invitation_faq .button .c_dl::before {
  content: '';
  width: 18px;
  height: 18px;
  background: url('../assets/img/upload.svg') no-repeat;
  background-size: cover;
  position: absolute;
  left: 0;
}

.l_invitation_faq .invitation-info-link {
  text-decoration: none;
  color: #66160E;
  font-size: 15px;
  font-weight: 600;
}

.friend-mission {
  margin-top: 12px;
  padding-left: 3%;
  padding-right: 3%;
}

.friend-mission-bg {
  position: relative;
  border-radius: 5px;
  border: 1px solid #66160E;
}

.friend-mission-bg span {
  font-family: 'HiraKakuPro-W8', sans-serif;
  font-weight: 800;
  font-size: 3vw;
  padding-top: 0;
}

.friend-mission-title {
  font-family: 'HiraKakuPro-W8', sans-serif;
  font-size: 4vw;
  font-weight: 800;
  background-color: #66160E;
  border-radius: 5px 5px 0 0;
  color: #ffffff;
  padding-top: 10px;
  padding-bottom: 10px;
}

.friend-mission-footer {
  font-family: 'HiraKakuPro-W8', sans-serif;
  font-size: 5vw;
  font-weight: 800;
  text-align: left;
  line-height: 1.2;
  background-color: var(--background-color);
  color: #66160E;
  padding-top: 2%;
  padding-left: 8%;
  padding-bottom: 2%;
  border-radius: 0 0 5px 5px;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.friend-mission-footer-text {
}

.friend-mission-footer-img {
  height: 100%;
  width: 40% !important;
  text-align: right;
  margin-right: 5px;
}

.friend-mission-content::before {
  content: '';
  width: 1em;
  height: 1em;
  background: url('../assets/img/invitation-lp/mission-logo.svg') no-repeat;
  background-size: cover;
  position: absolute;
  top: 0.5em;
  left: 0;
}

.friend-mission-content {
  font-family: 'HiraKakuPro-W6', sans-serif;
  width: 100%;
  padding-left: 6%;
  font-size: 4vw;
  font-weight: 600;
  text-align: left;
  color: #66160E;
  line-height: 2;
  position: relative;
}

.friend-mission-content-wrap {
  padding-top: 14px;
  padding-bottom: 14px;
  margin-left: 18%;
}
</style>
